// extracted by mini-css-extract-plugin
export default {"previewTd":"view_previewTd__gXAaw","previewTh":"view_previewTh__zy6EQ","previewTr":"view_previewTr__gXuxZ","previewTotal":"view_previewTotal__wCFLf"};